export const DEFAULT_IMG_USERS = process.env.REACT_APP_USERS_DEFAULT_AVATAR;
